function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 452.54 452.54",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M116.066,270.268c0,7.751-6.284,14.035-14.035,14.035H14.035C6.284,284.303,0,278.019,0,270.268 v-87.996c0-7.751,6.284-14.035,14.035-14.035h87.996c7.752,0,14.035,6.284,14.035,14.035V270.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M452.54,270.268c0,7.751-6.284,14.035-14.035,14.035h-87.997c-7.751,0-14.035-6.284-14.035-14.035 v-87.997c0-7.751,6.284-14.035,14.035-14.035h87.997c7.751,0,14.035,6.284,14.035,14.035V270.268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M270.272,2.305h-88.004c-7.749,0-14.032,6.283-14.032,14.04v87.989 c0,7.755,6.283,14.038,14.032,14.038h88.004c7.749,0,14.032-6.283,14.032-14.038V16.345 C284.304,8.588,278.021,2.305,270.272,2.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M102.028,2.305H14.04C6.283,2.305,0,8.588,0,16.345v87.989c0,7.755,6.283,14.038,14.04,14.038 h87.989c7.755,0,14.038-6.283,14.038-14.038V16.345C116.066,8.588,109.783,2.305,102.028,2.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M438.5,2.305h-87.988c-7.755,0-14.038,6.283-14.038,14.04v87.989 c0,7.755,6.283,14.038,14.038,14.038H438.5c7.757,0,14.04-6.283,14.04-14.038V16.345C452.54,8.588,446.257,2.305,438.5,2.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M270.272,168.236h-88.004c-7.749,0-14.032,6.283-14.032,14.04v87.989 c0,7.755,6.283,14.038,14.032,14.038h88.004c7.749,0,14.032-6.283,14.032-14.038v-87.989 C284.304,174.519,278.021,168.236,270.272,168.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M270.272,334.167h-88.004c-7.749,0-14.032,6.283-14.032,14.04v87.989 c0,7.755,6.283,14.038,14.032,14.038h88.004c7.749,0,14.032-6.283,14.032-14.038v-87.989 C284.304,340.45,278.021,334.167,270.272,334.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M116.066,436.2c0,7.751-6.284,14.035-14.035,14.035H14.035C6.284,450.235,0,443.951,0,436.2 v-87.996c0-7.751,6.284-14.035,14.035-14.035h87.996c7.752,0,14.035,6.284,14.035,14.035V436.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M452.54,436.2c0,7.751-6.284,14.035-14.035,14.035h-87.997c-7.751,0-14.035-6.284-14.035-14.035 v-87.997c0-7.751,6.284-14.035,14.035-14.035h87.997c7.751,0,14.035,6.284,14.035,14.035V436.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/Tool.cff2e614d94efc2dbe66cac49ded96e2.svg";
export { ForwardRef as ReactComponent };